<div class="stepper-container">
  <!-- Back Button -->
  <button class="back-button" type="button" (click)="onBackClick()">
    <img src="assets/agricola/back.svg" alt="" aria-hidden="true" class="back-icon" />
    <span>Atrás</span>
  </button>

  <!-- Steps -->
  <ol class="stepper-wrapper" aria-label="Progreso de apertura de póliza">
    <li
      *ngFor="let step of steps; let i = index"
      class="step-item"
      animate.enter="step-enter"
      animate.leave="step-leave"
      [class.completed]="isCompleted(i)"
      [class.active]="isActive(i)"
      [class.future]="isFuture(i)">
      
      <!-- Step Circle -->
      <button
        type="button"
        class="step-button"
        [disabled]="isFuture(i)"
        [attr.aria-current]="isActive(i) ? 'step' : null"
        (click)="onStepClick(i)">
        <span class="step-circle">
          <span class="step-check" aria-hidden="true" *ngIf="isCompleted(i)"></span>
          <span *ngIf="!isCompleted(i)">{{ i + 1 }}</span>
        </span>
        <span class="step-label">{{ step }}</span>
      </button>

      <!-- Connector Line (except for last step) -->
      <div class="step-connector" aria-hidden="true" *ngIf="i < steps.length - 1">
        <div class="connector-line" [class.completed]="isCompleted(i)"></div>
      </div>
    </li>
  </ol>
</div>
